import { render, staticRenderFns } from "./CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes.vue?vue&type=template&id=5fff3450&"
import script from "./CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes.vue?vue&type=script&lang=js&"
export * from "./CurrentResidenceTypeIsInterestedInHomeInsuranceQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports